import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Link } from 'react-router-dom';

interface Props {
  markdown: string;
}

export default function ChapterView({ markdown }: Props) {
  return (
    <div className="prose-doc">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a({ href, children, ...rest }) {
            // Same-origin odkazy (relativní `/c/...` i plné URL na doc.buydubai.eu)
            // jdou přes React Router — client-side navigace, stejné okno.
            // Externí (crm.buydubai.cz, portal, partneři) v novém okně.
            if (href) {
              try {
                const url = new URL(href, window.location.origin);
                if (url.origin === window.location.origin) {
                  return (
                    <Link to={url.pathname + url.search + url.hash} {...(rest as object)}>
                      {children}
                    </Link>
                  );
                }
              } catch {
                // neparsovatelný href (např. mailto:, tel:) — spadne dolů na <a>
              }
            }
            return (
              <a href={href} target="_blank" rel="noopener noreferrer" {...rest}>
                {children}
              </a>
            );
          },
        }}
      >
        {markdown || '_Tato kapitola zatím nemá publikovaný obsah._'}
      </ReactMarkdown>
    </div>
  );
}
